import type { FieldPayload, OutcomeVoucherRow } from '@FormModule';
import type { GenericField } from '@Types';
import { getPayloadDateString } from '@Helpers';
import { payloadSanitizerHelper } from '@FormModule';

function getSanitizedFieldPerName({ name, value }: FieldPayload) {
  switch (name) {
    case 'adoption_fee': {
      return value ? { adoption_fee_id: value } : {};
    }
    case 'additional_fees': {
      return {
        additional_fees: value ? value : [],
      };
    }
    // NOTE :: Wire shape the api stores on the cart line: a shelter wall-clock 'YYYY-MM-DD', or
    // null for "No expiration". Never toISOString() — it shifts the day by the browser timezone.
    case 'vouchers': {
      const rows: OutcomeVoucherRow[] = Array.isArray(value) ? value : [];

      return {
        vouchers: rows.map((row) => ({
          exp_date: row.no_expiration || !row.exp_date ? null : getPayloadDateString(row.exp_date),
          voucher_template_id: row.voucher_template_id,
        })),
      };
    }
    case 'file': {
      return {
        files: Array.isArray(value)
          ? value.map((file: any) => ({
              filename: file.name,
            }))
          : [],
      };
    }
  }
}

export default function (fields: Set<GenericField>) {
  let payload: { [key: string]: any } = {};
  const fieldNamesToBeSanitezed = ['adoption_fee', 'file', 'additional_fees', 'vouchers'];

  fields.forEach((field: GenericField) => {
    const entry = payloadSanitizerHelper(field, fieldNamesToBeSanitezed, getSanitizedFieldPerName);
    payload = { ...payload, ...entry };
  });

  return payload;
}
